export default (props = {}) => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="Close">
<path id="Vector" d="M10.5492 1.44922L1.44922 10.5492" stroke="#022535" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M1.44922 1.44922L10.5492 10.5492" stroke="#022535" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
